export enum SignatureStatuses {
  Created = 'created',
  Signed = 'signed',
  Declined = 'declined',
  Bounced = 'bounced_email',
  Cancelled = 'cancelled',
}
